
<template>
    <div ref="listWrap">
        <wrapper-list
                @delete="paasDeleteTableData"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@/components/paas/wrapper-list";
    import metaList from "@/assets/js/list/meta-list.js";
    import EnumShow from "@/components/paas/enum-show";  //如果有枚举，需要引入
    import CellBar from '@/components/paas/cell-bar' //列表内操作
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList,EnumShow  ,CellBar},
        data() {
            return {
                serviceUrl:"/api/pay/record",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                },
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        type: 'selection',  //type: 'selection'，即可自动开启多选功能
                        key: 'id',
                        width: 40,
                        align: 'center',
                    },
                    {
                        title: '订单号',
                        key: 'orderCode',
                    },
                    {
                        title: '交易方式',
                        key: 'tradeType',
                        render:(h,params)=>{
                            return h(EnumShow,{
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'tradeType',
                                    value:params.row.tradeType
                                }
                            })
                        }
                    },
                    {
                        title: '方法名',
                        key: 'methodName',
                    },
                    {
                        title: '返回值',
                        key: 'returnCode',
                    },
                    {
                        title: '提示信息',
                        key: 'returnMessage',
                    },
                    {
                        title: '返回json数据',
                        key: 'returnJson',
                    },
                    {
                        title: '操作',
                        render: (h, params) => {
                            return h(CellBar,
                                {
                                    props:{
                                        show:''  //操作也显示标准按钮的样式（text、icon、textIcon）
                                    },
                                    //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                                    on: {
                                        // 子组件$emit传递函数,必须是箭头函数写法
                                        'delete':()=>{
                                            this.$nextTick(()=>{
                                                this.paasDeleteOper(params.row[this.currentIdFiledName]);
                                            })
                                        },
                                        'edit': ()=> {
                                            this.$nextTick(()=>{
                                                this.paasEditOper(params.row[this.currentIdFiledName]);
                                            })
                                        },
                                    }
                                }
                            )
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
        }
    }
</script>
